export const JOBS = [
  // {
  //   id: "sales-development-representative",
  //   title: "Sales Development Representative (SDR)",
  //   category: "Sales",
  //   location: "Lahore, Pakistan",
  //   type: "Full-time",
  //   description:
  //     "As a Sales Development Representative (SDR), your role is pivotal in driving the growth of ExD Digital's B2B business. You will identify potential customers, align their personal and professional objectives with ExD Digital's value proposition, and set up the Account Executive team for successful deal closures. As a founding member of our rapidly growing sales team, your insights will be highly valued—from how we approach prospecting to refining our sales messaging and processes. We work collaboratively to achieve ambitious sales targets, and with this growth comes opportunities for career advancement at ExD Digital. You'll thrive in this role if you're a results-oriented, motivated, and strategic \"hunter\" focused on generating prospect meetings and building a robust sales pipeline. Daily, you will educate the market about ExD Digital's offerings and generate new business opportunities. You will also become proficient in using lead generation tools to extract relevant contacts and build accurate, targeted prospect lists.",
  //   responsibilities: [
  //     "Build and maintain a pipeline of prospective enterprise customers in the CRM tool.",
  //     "Research prospective companies to identify key stakeholders and support Account Executives in drafting value propositions.",
  //     "Understand the needs of target prospects and articulate ExD Digital's services via email and cold calls.",
  //     "Develop a deep understanding of ExD Digital's services and marketing messaging.",
  //     "Support new market development initiatives.",
  //   ],
  //   experience: {
  //     minimum: "Min 1 Year",
  //     timings: "6 PM to 3 AM PKT",
  //   },
  //   aboutUs:
  //     "Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since 1500, when designers at Letraset and James Mosley, the librarian at St Bride Printing Library, took a 1914 Cicero translation and scrambled it to make dummy text for Letraset's Body Type sheets. It has survived not only decades, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised thus more recently with desktop publishing software including versions of Lorem Ipsum.",
  //   whatWeOffer: [
  //     "Annual Paid Leaves",
  //     "Leave Encashment",
  //     "Fuel Certifications",
  //     "Health, Life Insurance",
  //     "Provident Fund",
  //     "Child Education Program",
  //   ],
  // },
];

export const CATEGORIES = [...new Set(JOBS.map((job) => job.category))];
export const LOCATIONS = [...new Set(JOBS.map((job) => job.location))];
